import { AnyFormControlModel } from '../dynamic-form-components/shared-models/any-form-control.model';
import { isNotEmpty } from './filter-props.helper';
import { isModelLoggable } from './is-model-loggable.helper';

/**
 * get value of a group of models as an object with properties equal to the values of the models
 */
export function getGroupValue<T = any>(models: AnyFormControlModel[], filterEmptyArrays?: boolean): T {
  return models.reduce((result, model) => {
    // if model is loggable and it either has a value or a group or groups, add it to the result
    if (isModelLoggable(model) && (isNotEmpty(model.value, filterEmptyArrays) || model.group || model.groups)) {
      return {
        ...result,
        [model.id]: model.group
                      ? getGroupValue(model.group)
                      : model.groups
            ? model.groups.map(mod => getGroupValue(mod.group))
            : model.value
      };
    }
    return result;
  }, {} as T);
}
